import { AddDestinationRequest, GetDestinationsResponse, GetNationalitiesResponse } from 'Application/models';
import { APICallInstance } from './APICallInstance';
import { AxiosResponse } from 'axios';

const destinationUrl = 'api/v1/destination';

export const getCountryDestinations = async () => {
    try {
        const response: AxiosResponse<GetDestinationsResponse> = await APICallInstance.get(`${destinationUrl}/all`);
        console.log(response);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const getCountryDestinationsDirectClient = async () => {
    try {
        const response: AxiosResponse<GetDestinationsResponse> = await APICallInstance.get(`${destinationUrl}/all`);
        console.log(response);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const AddNewDestinations = async (addDestionalData: AddDestinationRequest) => {
    try {
        const response: AxiosResponse<GetDestinationsResponse> = await APICallInstance.post(destinationUrl, addDestionalData);
        console.log(response);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const getNationalities = async () => {
    const url = `${destinationUrl}/nationality`;

    try {
        const response: AxiosResponse<GetNationalitiesResponse> = await APICallInstance.get(url);
        console.log(response);
        return response.data;
    } catch (error) {
        throw error;
    }
};
